<template>
  <div class="illustration-frameworks-content" id="identidade-visual-ilustracao-enquadramentos" data-search-anchor>
    <div class="illustration-frameworks-wrapper">
      <h1 class="illustration-frameworks-title-span">{{ frameworksTitleSpan }}</h1>
      <h1 class="illustration-frameworks-title">{{ frameworksTitle }}</h1>
    </div>

    <div class="description-illustration-frameworks-wrapper">
      <div class="illustration-frameworks-icon-wrapper">
        <IconCheck />
        <p class="illustration-frameworks-description">{{ frameworksDescription }}</p>
      </div>
    </div>

    <div
      class="illustration-frameworks-card-item"
      :style="{ backgroundImage: `url(${ImageSrc})` }"
    ></div>
  </div>
</template>

<script lang="ts">
import IconCheck from '@/assets/icons/IconCheck.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import IllustrationPageMixin from '@/mixins/illustration-page-mixin'
import { IllustrationPageStore } from '@/store/visual-identity-page/illustration-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({ components: { IconCheck } })
export default class IllustrationFrameworksSection extends Mixins(IllustrationPageMixin) {
  illustrationPageStore: PageStoreContract = getModule(IllustrationPageStore, this.$store)

  get frameworksTitleSpan(): string {
    return this.getElementTitle(7, 0)
  }

  get frameworksTitle(): string {
    return this.getElementText(7, 0)
  }

  get frameworksDescription(): string {
    return this.getElementText(7, 1)
  }

  get ImageSrc(): string {
    return this.getElementMedia(7, 2)
  }

  async getIllustrationPage(): Promise<void> {
    await this.illustrationPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.illustrationPageStore.isLoading) {
      await this.getIllustrationPage()
    }
  }
}
</script>

<style lang="scss">
.illustration-frameworks-content {
  display: grid;

  width: 100%;
  max-width: 1032px;
}

.illustration-frameworks-wrapper {
  display: flex;
  align-items: center;
  height: 6vh;
  padding-top: 6.25rem;
  padding-bottom: 1rem;
}

.illustration-frameworks-title-span {  
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  margin-right: 5px;
  color: #b3b3b3;
}

.illustration-frameworks-title {  
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  color: #000000;
}

.description-illustration-frameworks-wrapper {
  position: relative;
  
  display: grid;
  grid-template-columns: 50% 50%;  
}

.illustration-frameworks-icon-wrapper {
  display: flex;
  align-items: center;
}

.illustration-frameworks-description {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;

  padding-left: 7px;
  width: 378px;
}

.illustration-frameworks-card-item {
  position: relative;
  bottom: 0;
  
  max-width: 1032px;
  width: 100%;
  height: 705px;

  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
</style>
